export default "__VITE_ASSET__DcCgg$qe__"